// Style guide (.cursor/rules/style-guide.md) — "Admin / masquerade bar".
// Shared by SupportHeader and SupportToolsMenu; kept in its own module so the
// two components don't import each other.
//
// Dark neutral palette: the bar itself stays near-black (#151515). The
// "Support view" badge uses the same neutral/ghost surface as the rest of
// the bar's chrome (it is informational, not interactive). The magenta
// brand accent (#F90091) highlights the advertiser name being viewed, and
// a lighter pink (#FF4DB2) marks the *interactive* actions that operate on the
// advertiser being viewed (Advertiser settings / Tools) — chosen over the plain
// brand pink because it clears AA contrast against their tinted backgrounds.
//
// "Leave view" is deliberately a tier below those. It exits the masquerade
// context instead of acting on the advertiser, so it reuses the neutral ghost
// surface (the same one the non-interactive badge uses) with muted grey text.
// It stays an obvious button, but stops competing with the two actions beside it.
export const SUPPORT_PALETTE = {
  bg: "#151515",
  borderBottom: "1px solid #2A2A2A",
  textSecondary: "#B8B8B8", // "Viewing", "(id)" — ~9.2:1 on bg
  textStrong: "#FFFFFF", // badge text — ~14.8:1 on ghostBg-over-bg
  accentText: "#F90091", // emphasized advertiser name (brand pink) — ~4.73:1 on bg; also the Tools-menu item hover/active text on its #151515 row
  ghostBg: "rgba(255,255,255,0.08)", // badge background (non-interactive)
  ghostBorder: "1px solid rgba(255,255,255,0.2)",
  actionText: "#FF4DB2", // action-button text (Advertiser settings / Tools / Leave view) — ~5.49:1 on actionBg, ~5.01:1 on actionHoverBg
  actionBg: "rgba(249,0,145,0.14)",
  actionBorder: "1px solid rgba(249,0,145,0.4)",
  actionHoverBg: "rgba(249,0,145,0.22)",
  exitText: "#B8B8B8", // "Leave view" — tertiary exit, ~9.2:1 on bg
  exitBg: "rgba(255,255,255,0.08)",
  exitBorder: "1px solid rgba(255,255,255,0.2)",
  exitHoverBg: "rgba(255,255,255,0.16)",
  amberText: "#FCD34D",
  amberBg: "rgba(252,211,77,0.12)", // ~9.7:1 on bg
  amberBorder: "1px solid rgba(252,211,77,0.4)",
  focusRing: "#FFFFFF",
};

// The Tools dropdown renders through a portal onto the page body but, by user
// request, keeps the header's dark surface so the support chrome reads as one piece.
export const SUPPORT_MENU_PALETTE = {
  panelBg: SUPPORT_PALETTE.bg, // "#151515" — same dark surface as the header bar
  panelBorder: SUPPORT_PALETTE.borderBottom, // "1px solid #2A2A2A"
  itemText: SUPPORT_PALETTE.textStrong, // "#FFFFFF" — ~18.26:1 on panelBg
  muted: SUPPORT_PALETTE.textSecondary, // "#B8B8B8" — group headings, ~9.21:1 on panelBg
  inputBg: "rgba(255,255,255,0.08)",
  inputBorder: "1px solid rgba(255,255,255,0.2)",
};
